import React, { useState, useEffect, ReactNode } from 'react';
import styles from './BreakdownsContainer.module.scss';
import { useTranslation } from 'react-i18next';
import BreakdownsContainerTabs from './BreakdownsContainerTabs';

interface Tab {
  name: string;
  value: string;
}

interface BreakdownsContainerProps {
  children: ReactNode;
  title: string;
  onClick?: () => void;
  flexGrow?: number;
  flexBasis?: number;
  details?: boolean;
  onTabChange?: (tabValue: string | null) => void;
  tabs?: Tab[];
  filtersComponent?: ReactNode;
  paginationComponent?: ReactNode;
  customHeaderComponent?: ReactNode;
}

export const BreakdownsContainer = ({
  children,
  title,
  onClick,
  flexGrow=1,
  flexBasis=0,
  details=true,
  onTabChange=()=>{},
  tabs=[],
  filtersComponent,
  paginationComponent,
  customHeaderComponent,
}: BreakdownsContainerProps) => {
  const { t } = useTranslation();

  const [activeTab, setActiveTab] = useState<string | null>(tabs.length > 0 ? tabs[0].value : null);

  useEffect(() => {
    onTabChange(activeTab);
  }, [activeTab]);

  return (
    <div className={styles.breakdownContainerWrapper} style={{flexGrow: flexGrow, flexBasis: flexBasis}}>
      <div className={styles.header}>
        <div className={styles.headerTitle}>{t(title)}</div>
        {tabs?.length > 0 ? <BreakdownsContainerTabs tabsList={tabs} onChange={setActiveTab} activeTab={activeTab} /> : ''}
        {/* {details ? <div className={styles.headerButton} onClick={() => onClick()}>{t('View details')}</div> : ''} */}
        {customHeaderComponent}
      </div>
      {filtersComponent}
      <div className={styles.body}>{children}</div>
      {paginationComponent && (
        <div className={styles.pagination}>{paginationComponent}</div>
      )}
    </div>
  )
}

